'use strict';

import { io, sub, base, Component, PropTypes, cloneElement } from 'core';

import $style from './page.styl';

@base({
    styles: [ $style ],
    track: false
})
class HSPage extends Component {

    /* Sections core logics cache */
    sections = document.querySelectorAll('.section');
    activeSection = 0;
    animating = false;

    scrollTo = (target) => {

        if (!this.animating && target) {

            const targetX = $('.section-wrapper').offset().left - ($(target).offset().left )

            this.setState({ target: targetX });
        }
    }
    refreshPageSize = () => {

        let sum = Array.prototype.reduce.call(this.sections, function(sum, div){
            let width = div.getBoundingClientRect().width;
            return sum + width + 50;
        }, 0);

        document.querySelector('.section-wrapper')
                .style.width = (sum < 2300 ? 2300 : sum) + 'px';
    }
    onSectionGoClick = (side, touch) => {

        if ( side == 'left' && this.activeSection == 0 && !touch ) {/* Could go history.back */}
        else $('body').trigger($.Event('mousewheel'), (side == 'left' ? 1 : -1));
    }
    onBodyScroll = (event, delta) => {

        event.preventDefault();

        this.sections = document.querySelectorAll('.section');

        if ( !this.animating && delta < 0 ) {

            if (this.activeSection < this.sections.length-1 )
                this.scrollTo( this.sections[++this.activeSection] );

        } else if ( !this.animating && delta > 0 ){

            if (this.activeSection > 0 )
                this.scrollTo( this.sections[--this.activeSection] );
        }
    }
    refreshPage = () => {

        this.sections = document.querySelectorAll('.section');
        this.activeSection = 0;
        this.animating = false;

        if ( !this.animating
            && (($('.main-content').offset().left > 100)
             || ($('.main-content').offset().left < -100)))
            this.scrollTo(this.sections[this.activeSection]);

        this.refreshPageSize();
    }

    onSectionSwipeRight = () => this.onSectionGoClick('right', true);
    onSectionSwipeLeft = () => this.onSectionGoClick('left', true);

    onSectionGoRight = () => this.onSectionGoClick('right', false);
    onSectionGoLeft = () => this.onSectionGoClick('left', false);

    componentWillUnmount() {

        io.off('section:mounted', this.refreshPage);

        $('body').off('mousewheel', this.onBodyScroll);

        $('html,body').off('swipeleft', this.onSectionSwipeRight);
        $('html,body').off('swiperight', this.onSectionSwipeLeft);

        $('.section-go-left').off('click', this.onSectionGoLeft);
        $('.section-go-right').off('click', this.onSectionGoRight);
    }
    componentDidMount() {

        setTimeout(() => { io.emit('page:mounted') });

        io.on('section:mounted', this.refreshPage);

        $("body").on('mousewheel', this.onBodyScroll);

        $('html,body').on('swipeleft', this.onSectionSwipeRight);
        $('html,body').on('swiperight', this.onSectionSwipeLeft);

        $('.section-go-left').on('click', this.onSectionGoLeft);
        $('.section-go-right').on('click', this.onSectionGoRight);

        this.refreshPage();
    }
	render() {

        const { children } = this.props;
        const { target } = this.state || { target: 0 };

        const active = this.activeSection;
        const length = (this.sections ||[]).length -1;

  		return (
            <div className="hs_layout">

                <div className="section-wrapper" style={{ transform: `translateX(${target}px)` }}>
                    <div className="section-wrapper-current">
                        { cloneElement(children, this._atom()) }
                    </div>
                </div>

                <div ref="goLeft" className={`section-go section-go-left ${(active == 0) ? 'hidden' : ''}`}>
                    <i className="icon-caret_o_left"/>
                </div>
                <div ref="goRight" className={`section-go section-go-right ${(active == length) ? 'hidden' : ''}`}>
                    <i className="icon-caret_o_right"/>
                </div>
            </div>
  		);
	}
}

export default HSPage;



// WEBPACK FOOTER //
// ./ui/c/layout/hsLayout/index.jsx